import { useTranslation } from 'react-i18next';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetDiseasesQuery } from '@api/disease.api';

export default function DiseaseSelector(props: MultiSelectProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetDiseasesQuery();

  return (
    <MultiSelect
      label={t('selectors.disease.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.disease.placeholder')
      }
      data={data.map((disease) => ({
        label: disease.name,
        value: disease.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
